module.exports = __webpack_public_path__ + "static/media/jgwebcom.9e8f3454.svg";